namespace $.$$ {
	
	$mol_style_define( $shm_check_list, {

		All: {
			box: {
				shadow: [
					{ inset: false, x: 0, y: '1px', blur: 0, spread: 0, color: $mol_theme.line, },
				],
			},
		},
		
	} )
	
}
